<template>
  <page :manualInit="productMenu.init" :manualErr="productMenu.initErr" @reload="doInit">
    <div v-if="renderProductType">
      <v-subheader>{{labels.productType}}</v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorRatingReview'])">
            <v-card :class="isMatchRoute('motorProductList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedMotor">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelRatingReview'])">
            <v-card :class="isMatchRoute('travelProductList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedTravel">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireRatingReview'])">
            <v-card :class="isMatchRoute('fireProductList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedFire">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6>
            <v-card :class="isMatchRoute('paProductList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedPA">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoRatingReview'])">
            <v-card :class="isMatchRoute('cargoProductList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedCargo">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidRatingReview'])">
            <v-card :class="isMatchRoute('maidProductList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedMaid">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packageRatingReview'])">
            <v-card :class="isMatchRoute('packageProductList') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceedPackage">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <transition name="slide-x-transition" mode="out-in">
      <router-view></router-view>
    </transition>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import { appIcon } from '@/const/underwriting'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      labels: {
        productType: 'Product Type'
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    productMenu() {
      return this.$store.state.productManagement
    },
    renderProductType() {
      if (this.isMatchRouteExact('product')) {
        return true
      } else {
        return false
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    async doInit(title) {
      await this.$store.dispatch('productInit')
    },
    async doProceedMotor() {
      this.$router.push({ name: 'motorProductList' })
    },
    doProceedTravel() {
      this.$router.push({ name: 'travelProductList' })
    },
    doProceedFire() {
      this.$router.push({ name: 'fireProductList' })
    },
    doProceedCargo() {
      this.$router.push({ name: 'cargoProductList' })
    },
    doProceedMaid() {
      this.$router.push({ name: 'maidProductList' })
    },
    doProceedPackage() {
      this.$router.push({ name: 'packageProductList' })
    },
    doProceedPA() {
      this.$router.push({ name: 'paProductList' })
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "@/assets/scss/agency.scss";
</style>
